import formatDate, { dateFormat, getFormattedDate } from "../util/dateFormat";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { columns, columns1 } from "../static-models/ListVoucherData";
import useButtonStyles from "../styles/useButtonStyles";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import axios from "axios";
import { APIConstants } from "../constants/ApiConstants";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../redux/hooks";
import { formatDateReport, getEncodedValue } from "../components/forms/utility";
import mandatoryfields from "../assets/mandatorycolumns.png";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AddPhysicalVoucher from "./AddPhysicalVoucher";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import BasicTextField from "../components/forms/formElements/BasicTextField";
import PhysicalVoucherDetails from "./PhysicalVoucherDetails";
import { physicalVoucherAuctions } from "../redux/slices/PhysicalVoucherSlice";
import S3Instance from "../util/S3Instance";
import AlertModal from "../components/ui/Utils/Modal";
import InputProps, { DualInputProps } from "./SharedContents/InputProps";
import { operatorConstants } from "../util/SearchandFIlters/Constants";
import { getHashURL } from "../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../components/Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../Hooks/CustomHooks/UseGetTotalRecords";
import {
  bulkUpload,
  getInvalidCsvFile,
  getPhysicalVouchers,
} from "../services/ApiServices/vouchers";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  modelName,
} from "../constants/AppConstants";
import SearchInput from "../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../services/ApiServices/export";
import { usePermissionGetter } from "../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../Shared/Components/Buttons/CommonButton";
import useDateFilter from "../Hooks/Filters/useDateFilter";
import BasicModal from "../components/ui/BasicModal";

export interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
  dropdownOptions?: string[];
  isCheckbox?: boolean;
}

interface PVoucherData {
  id: string;
  reportId: string;
  merchant: number;
  companyName: number;
  voucherType: string;
  totalAmount: string;
  noOfVoucher: string;
  submissionDate: string;
  rejectionReason: string;
  status: string;
}

const PhysicalVoucherUpload = () => {
  const { getUserPermission: getPhysicalVoucherPermission } =
    usePermissionGetter("physical_voucher", "physical_voucher");
  const auditModeKey = "auditMode";
  const initialAuditMode = localStorage.getItem(auditModeKey) === "true";
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions,
  );

  const receiptsList = useAppSelector(
    (state: any) => state.persistReducers.getReceiptsList?.receiptsList,
  );
  const receiptsRandomList = useAppSelector(
    (state: any) => state.persistReducers.getReceiptsList?.receiptsRandomList,
  );

  const [data, setData] = useState<any>([]);
  const [randomData, setRandomData] = useState(
    receiptsRandomList?.length > 0 ? receiptsRandomList : [],
  );

  const [filteredData, setFilteredData] = useState<any[] | null>(null);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [errorAPI, setErrorAPI] = useState<boolean>(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [isRandomAudit, setIsRandomAudit] = useState(initialAuditMode);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const currentDate = formatDateReport(new Date().toISOString());
  const theme = useTheme();
  const buttonStyles = useButtonStyles();
  const [open, setOpen] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null | any>(null);
  const [showImageDialog, setShowImageDialog] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<PVoucherData[]>([]);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [deletionReason, setDeletionReason] = useState<any>({});
  //
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorValues, setErrorValues] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [filterActive, setFilterActive] = useState(false);
  //
  const [totalDataCount, setTotalDataCount] = useState<number>(0);
  const [nextPageKey, setNextPageKey] = useState<any>(null);
  const [apiFromKey, setApiFromKey] = useState<Number>(0);

  /// value for pooling api Timer
  const apiWaitInterval = 5000;
  const [timerId, setTimerId] = useState<any>();
  const [downlaodfileWithPath, setDownlaodfileWithPath] = useState<string>("");
  let apiThreshold = 0;
  const [downloadVoucherConent, setDownloadVoucherContent] =
    useState<ReactElement>(<></>);
  const [disableDownaloadBtn, setDisableDownloadBtn] = useState<boolean>(false);
  const [totalVoucherCount, setTotalVoucherCount] = useState<Number>(0);
  const [validVoucherCount, setValidVoucherCount] = useState<Number>(0);

  const [isFailure, setIsFailure] = useState<boolean>(false);
  const { totalCount, getTotalCounts, getTotalRecordsCount } =
    useGetTotalRecords();
  ///end of value for pooling api Timer

  ///search and Filter
  const modeDropDownOptions = [
    { id: "Import", label: "Import" },
    { id: "Manual", label: "Manual" },
  ];
  const VoucherStatusDropDownOptions = [
    { id: "Used", label: "Used" },
    { id: "Not Used", label: "Not Used" },
  ];
  const [type, setType] = useState<string>("");
  const [mode, setMode] = useState<string>("");
  const [voucherStatus, setVoucherStatus] = useState<string>("");

  const EntityValue = {
    issueDate: "issue_date",
    createdDate: "createdAt",
    expiryDate: "expiry_date",
    type: "type",
    mode: "mode",
    voucher_used: "voucher_used",
  };
  const { selectedDates, onUpdateFiltedDate, valueWithOperator, onResetDate } =
    useDateFilter([
      EntityValue.issueDate,
      EntityValue.expiryDate,
      EntityValue.createdDate,
    ]);

  const searchInputRef = useRef<HTMLInputElement>();
  const Navigate = useNavigate();

  const onResetData = () => {
    setData([]);
    setNextPageKey(null);
    setApiFromKey(0);
    setTotalDataCount(0);
  };
  const handleSearch = () => {
    onResetData();
    setIsInitalApiCall(true);
    // bindSearchandFilter();
  };

  const handleExport = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleShowImage = () => {
    setShowImageDialog(true);
  };

  const headerMapping: Record<string, string> = {
    id: "ID",
    voucherNo: "Voucher Number",
    amount: "Amount",
    soldTo: "Sold To",
    issueDate: "Issue Date",
    expiryDate: "Expiry Date",
    createdDate: "Created Date",
    type: "Type",
    remarks: "Remarks",
    voucherUsed: "Voucher Used",
    merchantName: "Merchant Name",
    mode: "Mode",
    voucher_number: "Voucher Number",
    issue_date: "Issue Date",
    expiry_date: "Expiry Date",
    whom_sold: "Whom Sold",
    voucher_used: "Voucher Used",
    created_by: "Created by",
    last_updated: "Last updated",
    reason: "Reason",
    isValidated: "Is Validated",
  };

  const formatCSVData = (data: any[]) => {
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
      };
      const excludedColumns = ["navigateTo", "id", "status"];
      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }

      return renamedRow;
    });
  };

  const handleSendExport = async () => {
    const getFilterURL = getFilterParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.physicalVoucher,
      hashKey.placeholderId,
      hashValue.allRecords,
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  const handleOpenImportDialog = () => {
    setOpenImportDialog(true);
  };

  const handleCloseImportDialog = () => {
    setOpenImportDialog(false);
    setLoading(false);
    clearTimeout(timerId);
  };

  const removeEmptyRows = (csvContent: string) => {
    const rows = csvContent.split("\n");
    const nonEmptyRows = rows.filter((row) => {
      return row.trim() !== "" && !/^,+$/g.test(row.trim());
    });
    const updatedCsvContent = nonEmptyRows.join("\n");
    return updatedCsvContent;
  };

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const formData = new FormData();
      if (!file || !file.name || !file.name.endsWith(".csv")) {
        throw new Error("File is either missing or not a CSV");
      }
      let filename: any = file?.name.split(".");
      const fileNameWithoutExtension = filename[0]
        .replace(/[^\w\s]/gi, "")
        .replace(/\s+/g, "");
      const fileExtension = filename[1];

      filename = `${
        "physical-voucher-csv/" + fileNameWithoutExtension
      }_${new Date().getTime()}.${fileExtension}`.trim();

      formData.append("csvFile", file, filename);
      setSelectedFile(formData);

      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   if (e.target?.result) {
      //     const csvContent = e.target.result as string;
      //     const updatedCsvContent = removeEmptyRows(csvContent);
      //     const blob = new Blob([updatedCsvContent], { type: "text/csv" });
      //     const updatedFile = new File([blob], file.name, { type: "text/csv" });
      //     setSelectedFile(updatedFile);
      //   }
      // };
      // reader.readAsText(file);
    }
  };

  const downloadInvalidCSV = (apiData: string) => {
    const fileData = new Blob([apiData], { type: "text/csv" });
    const doc = document.createElement("a");
    doc.href = URL.createObjectURL(fileData);
    doc.download = "Invalid_Voucher_List.csv";
    doc.click();
    setLoading(false);
  };

  const callPhysicalVoucherInvalidStatus = async (fileName: string) => {
    const url = `${process.env.REACT_APP_API_URL}${APIConstants.physicalVoucherStatus}${fileName}`;
    try {
      const response = await axios.get(url);
      const dataResponse = response?.data?.data?.data;
      if (dataResponse?.status === "complete") {
        createAlertContent(dataResponse);
        if (dataResponse?.invalid_voucher_count > 0) {
          const errorMessage = `Invalid Data: ${dataResponse.invalid_voucher_count}, Valid Data: ${dataResponse.valid_voucher_count}`;
          setErrorMessage(errorMessage);
          setShowErrorDialog(true);
          const fileWithPath = dataResponse?.key;
          setDownlaodfileWithPath(fileWithPath);
          setLoading(false);
          return;
        } else {
          createAlertContent(dataResponse);
          const errorMessage = `Invalid Data: ${dataResponse.invalid_voucher_count}, Valid Data: ${dataResponse.valid_voucher_count}`;
          setErrorMessage(errorMessage);
          setShowErrorDialog(true);
          setLoading(false);
          return;
        }
      }
      if (apiThreshold < 100) {
        apiThreshold++;
        callPoolingAPI(fileName);
      } else {
        throw new Error("Something went wrong, please try again later");
      }
    } catch (err: any) {
      console.error("pooling api fails ", err);
      handleCloseImportDialog();
    }
  };

  const createAlertContent = (response: any) => {
    const data = (
      <>
        <p>
          Data import succeeded :
          <span style={{ color: "green" }}>
            {" "}
            {response?.valid_voucher_count}
          </span>
        </p>
        <p>
          Data import Failed :
          <span style={{ color: "red" }}>
            {" "}
            {response?.invalid_voucher_count}
          </span>
        </p>
      </>
    );
    setTotalVoucherCount(response?.total_voucher_count);
    setValidVoucherCount(response?.valid_voucher_count);
    setDisableDownloadBtn(response?.invalid_voucher_count === 0);
    setDownloadVoucherContent(data);
  };

  // getInvalidCsvFile
  // const handleDownloadInValidCsv = () => {

  //   const instance = new S3Instance();
  //   instance.getObject(downlaodfileWithPath, downloadInvalidCSV);
  //   apiThreshold = 110;
  // };

  const handleDownloadInValidCsv = async () => {
    try {
      const response = await getInvalidCsvFile(downlaodfileWithPath);
      if (response.status) {
        downloadInvalidCSV(response?.data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const callPoolingAPI = (fileName: string) => {
    setTimerId(
      setTimeout(() => {
        callPhysicalVoucherInvalidStatus(fileName);
      }, apiWaitInterval),
    );
  };

  // const handleImport = async () => {
  //   if (selectedFile) {
  //     setLoading(true);
  //     try {
  //       apiThreshold = 0;
  //       const s3 = new S3Instance();
  //       const key = await s3.putObject(
  //         selectedFile,
  //         "physical-voucher-csv/",
  //         "text/csv"
  //       );

  //       const filePath = key?.split("/");
  //       const fileName = filePath[filePath.length - 1];
  //       callPoolingAPI(fileName);
  //     } catch (error) {
  //       console.error("handleImport error", error);
  //     }
  //   } else {
  //     console.error("No file selected for import");
  //   }
  // };

  const handleImport = async () => {
    setLoading(true);
    try {
      const response = await bulkUpload(selectedFile);

      if (response?.status) {
        const fileName = response?.fileName;
        callPoolingAPI(fileName);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  function generateErrorCSV(errorValues: any[] | null) {
    if (!errorValues || errorValues.length === 0) {
      return "";
    }

    const excludedColumns = ["id"];
    const fields = Object.keys(errorValues[0]).filter(
      (field) => !excludedColumns.includes(field),
    );

    const headerRow = fields.map((field) => {
      return headerMapping[field] || field;
    });

    const convertEpochToDate = (epoch: string | number | Date) => {
      const date = new Date(epoch);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const csvRows = [headerRow.join(",")];

    errorValues.forEach((row: { [x: string]: any }) => {
      const values = fields.map((field) => {
        if (field === "issue_date" || field === "expiry_date") {
          return convertEpochToDate(row[field]);
        } else {
          return JSON.stringify(row[field]);
        }
      });
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  }

  function downloadErrorCSV() {
    const csvContent = generateErrorCSV(errorValues);

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "errorData.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  const handleLocalDownload = () => {
    const exportableData = formatCSVData(data ? data : "");

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Report Title: Physical Voucher Report\nExport Date: ${currentDate}\n${csvRows.join(
        "\n",
      )}`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "physical-voucher.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };

  const handleDownloadPredefinedCSV = () => {
    const predefinedFileURL = require("../assets/PredefinedFile.csv");
    const a = document.createElement("a");
    a.href = predefinedFileURL;
    a.download = "PredefinedFile.csv";
    a.click();
  };
  //
  const [typeDropDownOptions, setListOfSourceVoucher] = useState<any>([]);
  const formatData = (list: any[]) => {
    return list.map((data: any) => {
      const item = data._source;

      return {
        id: item.id ? item.id : "-",
        voucherNo: item.voucher_number ? item.voucher_number : "-",
        amount: item.amount === "" ? "-" : item.amount,
        soldTo: item.whom_sold ? item.whom_sold : "-",
        issueDate: item.issue_date ? formatDate(item.issue_date, true) : "-",
        status: item.status ? item.status : "-",
        expiryDate: item?.expiry_date
          ? getFormattedDate(item.expiry_date, dateFormat.DMMMMYYYY)
          : "-",
        createdDate: item?.createdAt
          ? getFormattedDate(item.createdAt, dateFormat.DMMMMYYYY)
          : "-",

        type: item.type ? item.type : "-",
        remarks: item.remarks
          ? item.remarks === ""
            ? "-"
            : item.remarks
          : "-",
        voucherUsed: item.voucher_used ? item.voucher_used : "-",
        merchantName: item.merchant_name ? item.merchant_name : "-",
        mode: item.mode ? item.mode : "-",
        navigateTo: item.voucher_number
          ? `${"/uploadVoucher/"}${item.voucher_number}`
          : null,
        isValidated:
          item?.isValidated === true
            ? "Yes"
            : item?.isValidated === false
              ? "No"
              : "-",
      };
    });
  };

  const fetchVoucherByParams = async (
    querKey: string,
    canHaveExistingData?: boolean,
  ) => {
    try {
      setLoadingAPI(true);
      let querParams = `fromKey=${apiFromKey}`;
      if (querKey) querParams += `&${querKey}`;
      if (nextPageKey)
        querParams += `&lastKey=${encodeURIComponent(
          JSON.stringify(nextPageKey),
        )}`;
      const response = await getPhysicalVouchers(querParams);
      const { fromKey, lastKey, result, totalCount } = response?.data;

      setApiFromKey(fromKey);
      if (lastKey) {
        setNextPageKey(lastKey);
      } else setNextPageKey(null);
      setTotalDataCount(totalCount ? totalCount : 0);
      const vouchers = formatData(result);
      if (!typeDropDownOptions.length) {
        const uniqueSources = Array.from(
          new Set(vouchers.map((voucher: any) => voucher.type)),
        );
        const ConvertToObject = uniqueSources.map((source) => ({
          id: source,
          label: source,
        }));
        setListOfSourceVoucher(ConvertToObject);
      }
      setIsInitalApiCall(false);
      let dataToSet = canHaveExistingData ? [...data, ...vouchers] : vouchers;
      setData(dataToSet);
      dispatch(
        physicalVoucherAuctions.updateVoucherList({
          physicalVouchers: dataToSet,
        }),
      );
      setLoadingAPI(false);
    } catch (error: any) {
      setLoadingAPI(false);
      setIsInitalApiCall(false);
    }
  };

  useEffect(() => {
    if (selectedItems.length !== 0) {
      setShowDelete(true);
    } else {
      setShowDelete(false);
    }
  }, [selectedItems]);

  const handleCheckboxChange = (item: PVoucherData, checked: boolean) => {
    if (checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((selectedItem) => selectedItem !== item),
      );
    }
  };
  const handleDelete = async () => {
    const payload = selectedItems.map((item: any) => ({
      voucher_number: item.voucherNo,
      status: "Deleted",
      reason: deletionReason.reason,
    }));

    setLoadingAPI(true);

    try {
      setLoadingAPI(true);
      const axiosResponse = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.physicalVoucherRemove,
        payload,
      );
      setShowModal(true);
      setLoadingAPI(false);
      setOpenDeleteDialog(false);
      setShowDelete(false);
      setSelectedItems([]);
      setIsInitalApiCall(true);
    } catch (error) {
      setShowModal(true);
      console.error(error, "error");
      setLoadingAPI(false);
      setIsFailure(true);
      setShowDelete(false);
      setIsInitalApiCall(true);
      setSelectedItems([]);
    } finally {
      // setShowDelete(false);
      setLoadingAPI(false);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 500);
    }
  };

  // for filtering
  const [openFilter, setOpenFilter] = useState(false);

  const handleFilterClose = () => {
    setOpenFilter(false);
  };

  //add Physical voucher
  const [showAddPhysicalVoucher, setShowAddPhysicalVoucher] = useState(false);
  //show details of Voucher
  const vouchersList = useAppSelector(
    (state: any) => state.persistReducers.physicalVoucherSlice.physicalVouchers,
  );
  const params = useParams();
  const { voucherDetails } = params;
  const [showVoucher, setShowVoucher] = useState(false);
  const [singleVoucher, setSingleVoucher] = useState<any>({});
  /// filter Data
  const [updatedFilterDate, setUpdateFilterDate] = useState({});
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(true);
  const [isInitalApiCall, setIsInitalApiCall] = useState<boolean>(true);

  const navigateToVoucher = () => {
    setShowVoucher(false);
    Navigate("/uploadVoucher");
  };

  useEffect(() => {
    if (isInitalApiCall) bindSearchAndFilter();
  }, [isInitalApiCall]);

  useEffect(() => {
    if (voucherDetails) {
      const vouchers = vouchersList.filter(
        (voucher: any) => voucher.voucherNo === voucherDetails,
      );
      const singleVoucher = vouchers[0];
      setSingleVoucher(singleVoucher);

      setShowVoucher(true);
    }
  }, [voucherDetails]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const handleCloseDelete = () => {
    setOpenDeleteDialog(false);
  };

  const itemToVommit = (item: any) => {
    return !(item.voucherUsed.toLowerCase() === "used");
  };

  const getDateValue = (fieldItem: any) => {
    const item = updatedFilterDate[fieldItem as keyof typeof updatedFilterDate];
    return item !== undefined ? item : "";
  };
  const onInputDateChange = (filedName: string, value: any) => {
    setUpdateFilterDate((prevState) => ({
      ...prevState,
      [filedName]: value,
    }));
  };
  const getFilterDates = () => {
    const data = Object.keys(updatedFilterDate).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedFilterDate[item as keyof typeof updatedFilterDate],
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getTypeandModeandVoucherStatus = () => {
    const typeandMode = [];
    if (type !== "")
      typeandMode.push({
        fieldValue: EntityValue.type,
        value: type,
        operator: operatorConstants.equal,
      });
    if (mode !== "")
      typeandMode.push({
        fieldValue: EntityValue.mode,
        value: mode,
        operator: operatorConstants.equal,
      });
    if (voucherStatus !== "")
      typeandMode.push({
        fieldValue: EntityValue.voucher_used,
        value: voucherStatus,
        operator: operatorConstants.equal,
      });

    return typeandMode;
  };
  const getFilterValues = () => {
    // const filterDateParam = getFilterDates();
    const filterDateParam = valueWithOperator;
    const filterTypes = getTypeandModeandVoucherStatus();
    const status = [
      { fieldValue: "status", operator: "eq", value: filterConstants.Active },
    ];
    const filterParam = [...filterDateParam, ...filterTypes, ...status];
    return filterParam;
  };
  const handleApplyFilter = () => {
    onResetData();
    setOpenFilter(false);
    setIsFilterApplied(true);
    setIsInitalApiCall(true);
    const generatedURL = getFilterParams();
    const searchParams = new URLSearchParams(generatedURL);
    const filtersValue = searchParams.get("filters");
    filtersValue && setFilterActive(true);
  };
  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const url = getFilterParams();
    const apiCall = Boolean(!canHaveExistingData);
    setIsInitalApiCall(apiCall);
    fetchVoucherByParams(url, canHaveExistingData);
    return url;
  };
  const getFilterParams = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const filterParam = getFilterValues();
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValues,
      searchData: searchParam,
      filterData: filterParam,
    };
    const url = getHashURL(params);

    return url;
  };
  const handleResetFilter = () => {
    onResetDate();
    setUpdateFilterDate({});
    setMode("");
    setType("");
    setVoucherStatus("");
    onResetData();
    setIsFilterApplied(false);
    setIsInitalApiCall(true);
    setFilterActive(false);
  };

  const onRefresh = () => {
    onResetData();
    setIsInitalApiCall(true);
  };

  return (
    <Grid
      borderRadius={"16px"}
      sx={{ background: theme.color?.background }}
      p={4}
      px={2}
    >
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        width={"100%"}
        alignItems={"center"}
        sx={{ fontFamily: theme?.font?.fontFamily.primary }}
      >
        <Grid
          borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          container
          display={"flex"}
          height={"6.25rem"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ background: theme.color?.background }}
        >
          <Drawer
            anchor={"right"}
            open={showVoucher}
            onClose={() => {
              navigateToVoucher();
            }}
            sx={{
              "& .MuiPaper-root": {
                borderRadius: "16px 0 0 16px",
              },
            }}
          >
            <Grid width={"40vw"} height={"100%"}>
              <PhysicalVoucherDetails
                closeDrawer={setShowVoucher}
                voucher={singleVoucher}
              />
            </Grid>
          </Drawer>
          <Grid
            item
            lg={4}
            pl={4}
            style={{
              borderColor: "red",
              color: theme.color?.primary,
              fontWeight: "bold",
              fontSize: "20px",
              display: "flex",
              fontFamily: theme.font?.fontFamily.primary,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: theme?.color?.primary,
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: "700",
              }}
              px={2}
            >
              Physical Voucher
            </Typography>
          </Grid>

          <Grid
            item
            container
            lg={8}
            px={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "",
            }}
          >
            <ExportDialog
              closeDialog={setOpen}
              emailSent={emailSent}
              exportTitle="Physical Vouchers"
              handleClose={handleClose}
              open={open}
              sending={sending}
              handleSendExport={handleSendExport}
            />

            {getPhysicalVoucherPermission("create") && (
              <CommonButton
                buttonTitle="Import"
                variant="text"
                color="secondary"
                onClick={handleOpenImportDialog}
                sx={{ ml: 2 }}
              />
            )}
            {getPhysicalVoucherPermission("create") && (
              <CommonButton
                buttonTitle=" Add Voucher"
                variant="contained"
                color="secondary"
                onClick={() => setShowAddPhysicalVoucher(true)}
                sx={{ ml: 2 }}
              />
            )}
            <Drawer
              anchor={"right"}
              open={showAddPhysicalVoucher}
              onClose={() => {
                setShowAddPhysicalVoucher(false);
              }}
              sx={{
                "& .MuiPaper-root": {
                  borderRadius: "16px 0 0 16px",
                },
              }}
            >
              <Grid width={"657px"} height={"100%"}>
                <AddPhysicalVoucher
                  showPhysicalVoucher={setShowAddPhysicalVoucher}
                  onRefresh={onRefresh}
                />
              </Grid>
            </Drawer>
            <Dialog open={openImportDialog} onClose={handleCloseImportDialog}>
              {loading ? (
                <img src={require("../assets/ZNeT.gif")} alt="Loading gif" />
              ) : (
                <>
                  <DialogTitle
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    <DialogTitle sx={{ fontWeight: "600" }}>
                      Import CSV File
                    </DialogTitle>
                    <DialogActions>
                      <IconButton
                        aria-label="delete"
                        onClick={handleDownloadPredefinedCSV}
                        sx={{
                          color: theme.color?.secondary,
                        }}
                      >
                        <DownloadForOfflineRoundedIcon />
                      </IconButton>
                    </DialogActions>
                  </DialogTitle>
                  <DialogContent>
                    <TextField
                      type="file"
                      onChange={handleFileInputChange}
                      sx={{
                        color: theme.color?.secondary,
                      }}
                      inputProps={{
                        accept: ".csv",
                      }}
                    />
                  </DialogContent>
                  <DialogActions
                    sx={{
                      marginBottom: 2,
                      justifyContent: "center",
                      padding: 2,
                    }}
                  >
                    <CommonButton
                      buttonTitle="Cancel"
                      variant="outlined"
                      color="secondary"
                      sx={{ width: "45%", mr: 2 }}
                      onClick={handleCloseImportDialog}
                    />
                    <Button
                      onClick={handleImport}
                      sx={{
                        ...buttonStyles.containedSecondary,
                        width: "45%",
                        ml: 2,
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={24} color="primary" />
                      ) : (
                        // <img
                        //   src={require("../assets/9gu9.gif")}
                        //   alt="Loading gif"
                        //   sizes={"24"}
                        // />
                        "Import"
                      )}
                    </Button>
                  </DialogActions>
                </>
              )}
            </Dialog>
            <Dialog
              open={showImageDialog}
              onClose={() => setShowImageDialog(false)}
            >
              <DialogTitle display={"flex"} justifyContent={"space-between"}>
                <Typography
                  display={"flex"}
                  alignItems={"center"}
                  sx={{ fontFamily: theme.font?.fontFamily.primary }}
                >
                  Mandatory Headers
                </Typography>
                <DialogActions>
                  <IconButton
                    aria-label="close"
                    onClick={() => setShowImageDialog(false)}
                    sx={{
                      color: theme.color?.secondary,
                    }}
                  >
                    <ClearOutlinedIcon />
                  </IconButton>
                </DialogActions>
              </DialogTitle>
              <DialogContent sx={{ marginBottom: 4, mx: 3 }}>
                <img src={mandatoryfields} alt="Image" />
              </DialogContent>
            </Dialog>
            <Dialog
              open={openDeleteDialog}
              onClose={handleCloseDelete}
              sx={{ marginRight: "52%" }}
            >
              <Grid
                display={"flex"}
                direction={"column"}
                sx={{
                  width: "439px",
                  height: "348px",
                }}
                p={4}
              >
                <Grid
                  item
                  lg={4}
                  style={{
                    color: theme.color?.primary,
                    fontWeight: "bold",
                    fontSize: "20px",
                    display: "flex",
                    fontFamily: theme.font?.fontFamily.primary,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: theme?.color?.primary,
                      fontFamily: theme.font?.fontFamily.primary,
                      fontWeight: "700",
                    }}
                  >
                    Delete Physical Voucher
                  </Typography>
                </Grid>
                <Grid
                  pb={3}
                  borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
                >
                  <BasicTextField
                    stateKey="reason"
                    placeholder=""
                    label="Deletion Reason"
                    rows={3}
                    multiline
                    value={deletionReason}
                    setState={setDeletionReason}
                  />
                </Grid>
                <Grid display={"flex"} alignItems={"center"} gap={3} pt={3}>
                  <CommonButton
                    buttonTitle="Cancel"
                    variant="outlined"
                    color="secondary"
                    onClick={() => setOpenDeleteDialog(false)}
                  />
                  <Button
                    sx={buttonStyles.containedPrimary}
                    variant="contained"
                    onClick={handleDelete}
                  >
                    {loadingAPI ? (
                      <CircularProgress size={24} color="primary" />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Dialog>
          </Grid>
        </Grid>
        <Grid
          container
          display={"flex"}
          height={"6.25rem"}
          alignItems={"center"}
          justifyContent={"left"}
          pr={3}
          ml={2}
          sx={{ background: theme.color?.background }}
        >
          <Grid display={"flex"} width={"45%"}>
            {getPhysicalVoucherPermission("delete") && showDelete && (
              <CommonButton
                buttonTitle="Delete"
                variant="contained"
                color="error"
                onClick={() => setOpenDeleteDialog(true)}
              />
            )}
          </Grid>
          <Grid
            display={"flex"}
            direction={"row"}
            width={"50%"}
            justifyContent={"end"}
            alignItems={"center"}
            gap={4}
          >
            {getPhysicalVoucherPermission("read") && (
              <CommonButton
                buttonTitle="Export"
                variant="text"
                color="secondary"
                onClick={handleExport}
                disabled={!data.length}
              />
            )}
            {getPhysicalVoucherPermission("read") && (
              <CommonButton
                buttonTitle="Download"
                variant="text"
                color="secondary"
                onClick={handleLocalDownload}
                disabled={!data.length}
                endIcon={<DownloadForOfflineRoundedIcon />}
              />
            )}

            <Grid
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid display={"flex"}>
                <Grid
                  display={"flex"}
                  justifyContent={"center"}
                  px={0}
                  py={3}
                  direction={"row"}
                >
                  {getPhysicalVoucherPermission("read") && (
                    <Grid display={"flex"} gap={2}>
                      <SearchInput
                        HelpTip={SearchToolTip.PVoucher}
                        onCallBack={handleSearch}
                        width="250px"
                        ref={searchInputRef}
                      />
                      <Button
                        variant="text"
                        startIcon={
                          filterActive ? (
                            <FilterAltIcon
                              sx={{ color: theme.color?.secondary }}
                            />
                          ) : (
                            <FilterAltOutlinedIcon />
                          )
                        }
                        sx={{
                          color: theme.color?.newFilterGrey,
                          textTransform: "capitalize",
                        }}
                        onClick={() => {
                          setOpenFilter(true);
                        }}
                      >
                        Filter
                      </Button>
                    </Grid>
                  )}
                  <Dialog
                    onClose={handleFilterClose}
                    open={openFilter}
                    sx={{ ml: "60vw" }}
                  >
                    <Grid sx={{ width: "483px", py: 4, px: 2 }}>
                      <DialogTitle
                        display={"flex"}
                        justifyContent={"space-between"}
                        borderBottom={theme.border?.smallGrey}
                      >
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            color: theme.color?.primary,
                            fontSize: theme.font?.fontSize.large,
                            fontWeight: theme.font?.fontWeight.thicker,
                          }}
                        >
                          Filter
                        </Typography>
                        <IconButton onClick={handleFilterClose}>
                          <CloseOutlinedIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent
                        sx={{ borderBottom: theme.border?.smallGrey }}
                      >
                        {/* <InputProps
                          label="Issue Date"
                          value={getDateValue(EntityValue.issueDate)}
                          type="Date"
                          inputPlaceHolder="Please select Data"
                          onInputChange={(data) =>
                            onInputDateChange(
                              EntityValue.issueDate,
                              data.target.value
                            )
                          }
                        /> */}
                        <DualInputProps
                          label="Issue Date"
                          fromTitle="From"
                          toTitle="To"
                          fromOnChange={(data) => {
                            onUpdateFiltedDate(
                              EntityValue.issueDate,
                              "fromDate",
                              data.target.value,
                            );
                          }}
                          toOnChange={(data) => {
                            onUpdateFiltedDate(
                              EntityValue.issueDate,
                              "toDate",
                              data.target.value,
                            );
                          }}
                          fromValue={
                            selectedDates[
                              EntityValue.issueDate
                            ]?.fromDate?.toString() || ""
                          }
                          toValue={
                            selectedDates[
                              EntityValue.issueDate
                            ]?.toDate?.toString() || ""
                          }
                          type="Date"
                        />
                        {/* <InputProps
                          label="Expiry Date"
                          value={getDateValue(EntityValue.expiryDate)}
                          type="Date"
                          inputPlaceHolder="Please select Data"
                          onInputChange={(data) =>
                            onInputDateChange(
                              EntityValue.expiryDate,
                              data.target.value
                            )
                          }
                        /> */}
                        <DualInputProps
                          label="Expiry Date"
                          fromTitle="From"
                          toTitle="To"
                          fromOnChange={(data) => {
                            onUpdateFiltedDate(
                              EntityValue.expiryDate,
                              "fromDate",
                              data.target.value,
                            );
                          }}
                          toOnChange={(data) => {
                            onUpdateFiltedDate(
                              EntityValue.expiryDate,
                              "toDate",
                              data.target.value,
                            );
                          }}
                          fromValue={
                            selectedDates[
                              EntityValue.expiryDate
                            ]?.fromDate?.toString() || ""
                          }
                          toValue={
                            selectedDates[
                              EntityValue.expiryDate
                            ]?.toDate?.toString() || ""
                          }
                          type="Date"
                        />
                        {/* <InputProps
                          label="Created Date"
                          value={getDateValue(EntityValue.createdDate)}
                          type="Date"
                          inputPlaceHolder="Please select Data"
                          onInputChange={(data) =>
                            onInputDateChange(
                              EntityValue.createdDate,
                              data.target.value
                            )
                          }
                        /> */}
                        <DualInputProps
                          label="Created Date"
                          fromTitle="From"
                          toTitle="To"
                          fromOnChange={(data) => {
                            onUpdateFiltedDate(
                              EntityValue.createdDate,
                              "fromDate",
                              data.target.value,
                            );
                          }}
                          toOnChange={(data) => {
                            onUpdateFiltedDate(
                              EntityValue.createdDate,
                              "toDate",
                              data.target.value,
                            );
                          }}
                          fromValue={
                            selectedDates[
                              EntityValue.createdDate
                            ]?.fromDate?.toString() || ""
                          }
                          toValue={
                            selectedDates[
                              EntityValue.createdDate
                            ]?.toDate?.toString() || ""
                          }
                          type="Date"
                        />
                        <InputProps
                          label="Type"
                          value={type}
                          type="Select"
                          inputPlaceHolder="Please select Data"
                          onInputChange={(data) => setType(data.target.value)}
                          options={typeDropDownOptions}
                        />
                        <InputProps
                          label="Mode"
                          value={mode}
                          type="Select"
                          inputPlaceHolder="Please select Data"
                          onInputChange={(data) => setMode(data.target.value)}
                          options={modeDropDownOptions}
                        />
                        <InputProps
                          label="Voucher Status"
                          value={voucherStatus}
                          type="Select"
                          inputPlaceHolder="Please select Data"
                          onInputChange={(data) =>
                            setVoucherStatus(data.target.value)
                          }
                          options={VoucherStatusDropDownOptions}
                        />
                      </DialogContent>
                      <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
                        <Button
                          onClick={handleResetFilter}
                          sx={{ ...buttonStyles.outlinedSecondary }}
                        >
                          Reset
                        </Button>
                        <Button
                          sx={{ ...buttonStyles.containedSecondary }}
                          onClick={handleApplyFilter}
                        >
                          Apply
                        </Button>
                      </DialogActions>
                    </Grid>
                  </Dialog>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container width={"100%"} px={2} mt={2}>
        {getPhysicalVoucherPermission("read") && (
          <InfiniteTable
            header={getPhysicalVoucherPermission("delete") ? columns : columns1}
            contentItems={data}
            fetchMoreData={() => bindSearchAndFilter(true)}
            hasMoreRecords={nextPageKey !== null}
            filterCondition={itemToVommit}
            onInputChange={handleCheckboxChange}
            isInitialLoading={data.length === 0 && loadingAPI}
            totalRecords={totalDataCount}
          />
        )}
      </Grid>
      <Dialog
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
      >
        <DialogTitle sx={{ color: theme.color?.success, textAlign: "center" }}>
          Success
        </DialogTitle>
        <DialogContent>
          <Typography>{successMessage}</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 6, pb: 2 }}>
          <Button
            sx={{ ...buttonStyles.containedSecondary }}
            onClick={() => setShowSuccessDialog(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <AlertModal
        open={showErrorDialog}
        title={`Total data upload : ${totalVoucherCount}`}
        onSubmit={handleDownloadInValidCsv}
        onSubmitTitle="Download failed files"
        content={downloadVoucherConent}
        canDisable={disableDownaloadBtn}
        onClose={() => {
          setOpenImportDialog(false);
          setShowErrorDialog(false);
          if (validVoucherCount) {
            setValidVoucherCount(0);
            onRefresh();
          }
        }}
      />

      {isFailure && (
        <BasicModal
          title={"Api Failed"}
          setState={setIsFailure}
          // success={apiSuccess}
          // redirection="/admin?tab=shopUser"
          onCloseModule={() => {
            setIsFailure(false);
            // onCloseModule();
          }}
        />
      )}
    </Grid>
  );
};

export default PhysicalVoucherUpload;
